import axios from 'axios';

// In local dev REACT_APP_API_URL=http://localhost:3001 bypasses the CRA proxy so
// the browser talks directly to NestJS and cookies are always same-origin.
// In production leave REACT_APP_API_URL unset; nginx proxies /api on the same domain.
const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL ?? ''}/api`,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// On 401 → redirect to backend login flow.
// Exclude /auth/* paths so that login-page calls (wrong credentials, expired OTP, etc.)
// surface their errors inline rather than bouncing through the PKCE redirect.
api.interceptors.response.use(
  (res) => res,
  (err) => {
    const url: string = err.config?.url ?? '';
    const isAuthEndpoint = url.includes('/auth/');
    if (err.response?.status === 401 && !isAuthEndpoint) {
      window.location.href = '/login';
    }
    return Promise.reject(err as Error);
  },
);

export default api;
